import { FilterPill, SrpColorsFilterValue } from 'types/srpFilters';
import { FilterPillFn } from 'components/Srp/FilterPills/hooks/useCreateFilterPills';
import { useTranslation } from 'react-i18next';

export default function useColorFilterOptionsPillsCreators(): FilterPillFn {
  const { t } = useTranslation();

  return (colorFilters: SrpColorsFilterValue): FilterPill[] => {
    const exteriorColors = colorFilters.exterior;
    const interiorColors = colorFilters.interior;

    const exteriorColorPills = Object.entries(exteriorColors)
      .filter(([, isSelected]) => isSelected)
      .map(([colorKey]) => {
        return {
          name: colorKey,
          label: `${t(`srp.pills.${colorKey}`)} ${t('srp.pills.ext')}`,
          resetState: { Colors: { exterior: { [colorKey]: false } } },
        };
      });

    const interiorColorPills = Object.entries(interiorColors)
      .filter(([, isSelected]) => isSelected)
      .map(([colorKey]) => {
        return {
          name: colorKey,
          label: `${t(`srp.pills.${colorKey}`)} ${t('srp.pills.int')}`,
          resetState: { Colors: { interior: { [colorKey]: false } } },
        };
      });

    return [...exteriorColorPills, ...interiorColorPills];
  };
}
